<template>
  <div>
    Test main입니다.
    <br/>추후 제거 예정입니다.
    <br/>개발시 index.js에 url을 추가하여 주세요. url이 화면정의서와 다르다면 문의바랍니다.
    <br/>공통코드는 code store를 참고 바랍니다.
    <br/>다른 문의는 란D에게 문의바랍니다.

    <br/>
    EX:
    {
    path: '/admin/main',
    name: 'AdminMain',
    component: AdminMain,
    beforeEnter: requireAdmin(),
    meta: {
    layout: 'AdminLayout'
    }

    }
  </div>
</template>

<script>
  import JwtService from "../../../common/jwt.service";
  import ApiConfig from "../../../api/api.config"

  export default {
   data() {
      return {
         platformDomain : ApiConfig.platformDomain
      }
    },
    methods:{

    }
  }
</script>

